import clsx from "clsx";
import { openDialog } from "app/store/fuse/dialogSlice";
import Confirm from "@fuse/core/FuseDialog/confirm";
import { useState } from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { useDispatch, useSelector } from "react-redux";
import { showMessage } from "app/store/fuse/messageSlice";
import {
  deleteShipments,
  getShipments,
  setSelectedShipments,
} from "../store/shipmentsSlice";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    minHeight: "45px",
    paddingLeft: "0px",
    color: theme.palette.text.primary,
  },
  colorBox: {},
}));

function ShipmentsToolBar(props) {
  const dispatch = useDispatch();
  const classes = useToolbarStyles();
  const {
    toolbarParam,
  } = props;
  const { selectedShipments } = toolbarParam;
  const selectedShipmentIds = selectedShipments.map(
    (shipment) => shipment.shipment_id
  );

  const currentUser = useSelector(({ user }) => user);
  const [loading, setLoading] = useState(false);

  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {selectedShipments && selectedShipments?.length > 0 ? (
        <Toolbar className={clsx(classes.root, "flex items-start")}>
          <>
            <div className="flex flex-row items-center">
              <Box className="flex items-center font-medium font-bold">
                {selectedShipments?.length}
              </Box>
              <Typography className="pl-8 font-medium" color="inherit">
                {toolbarParam?.selectionMsg
                  ? toolbarParam?.selectionMsg
                  : "Shipment(s) Selected"}
              </Typography>
            </div>
            {currentUser?.role === "admin" && (
              <>
                <Button
                  color="secondary"
                  size="small"
                  variant="contained"
                  sx={{ padding: "0px 15px", marginLeft: "10px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatch(
                      openDialog({
                        children: (
                          <Confirm
                            title="Delete Shipment(s)"
                            content="Are you sure you want to permanently delete the selected shipment(s)?"
                            onSubmit={() => {
                              setLoading(true);
                              dispatch(
                                deleteShipments({
                                  shipment_ids: selectedShipmentIds,
                                })
                              ).then((res) => {
                                setLoading(false);
                                if (!res.error) {
                                  dispatch(
                                    showMessage({
                                      message:
                                        "Selected shipment(s) has been deleted successfully",
                                      type: "success",
                                    })
                                  );
                                  dispatch(setSelectedShipments({ data: [] }));
                                  dispatch(
                                    getShipments({
                                      params: {},
                                      goToFirstPage: true,
                                    })
                                  );
                                } else {
                                  dispatch(setSelectedShipments({ data: [] }));
                                  dispatch(
                                    showMessage({
                                      message:
                                        "Failed to delete selected shipment(s)",
                                      type: "error",
                                    })
                                  );
                                }
                              });
                            }}
                          />
                        ),
                      })
                    );
                  }}
                >
                  Delete Shipment
                </Button>
              </>
            )}
          </>
        </Toolbar>
      ) : (
        <></>
      )}
    </>
  );
}

export default ShipmentsToolBar;
